import { APIClient } from "./_api";

export function enterMobile(data) {
  return APIClient.post(`login`, data);
}
export function logout(data) {
  return APIClient.post(`logout`, data);
}
export function confirmLogin(data) {
  return APIClient.post(`loginConfirm`, data);
}

export function getProfile(data) {
  return APIClient.post(`userProfile`, data);
}

export function editProfile(data) {
  return APIClient.post(`editUserData`, data);
}
export function getMobileUser(data) {
  return APIClient.post(`user_mobile`, data);
}
export function getVisits(data) {
  return APIClient.post(`userProfileVisits`, data);
}
export function getComments(data) {
  return APIClient.post(`userComments`, data);
}
export function addNotifToken(data) {
  return APIClient.post(`add_notif_token`, data);
}
export function telegramLink(data) {
  return APIClient.post(`get_telegram_link`, data);
}
export function addUserComment(data) {
  return APIClient.post(`addUserComment`, data);
}
export function sendActiveEmail(data) {
  return APIClient.post(`sendActiveEmail`, data);
}
export function activeEmail(data) {
  return APIClient.post(`activeEmail`, data);
}
